import { PDFDocument } from 'pdf-lib';
import { breakWaiverPdf } from './breakWaiverPdf';
import moment from 'moment';
import { hourlyRate, regularHourRate, workingDays, workingHours } from 'src/constants/offerLeter';
import { vtcPdf } from './vtcPdf';
import { cacPdf } from './cacPdf';
import { bicfPdf } from './bicfPdf';
import { disclousurePdf } from './disclousurePdf';
import { handbookPdf } from './handbookPdf';
import globalutil from 'src/util/globalutil';

export const generateDAcontracts = async (
  breakWaiver,
  path,
  dsp,
  da,
  signature,
  onlyPreview = false,
) => {
  const variables = {
    DATE: signature ? moment(da?.createdAt).format('MM/DD/YYYY') : moment().format('MM/DD/YYYY'),
    DSP_NAME: dsp?.name ?? '',
    DSP_ADDRESS: dsp?.surfaceAddress ?? '',
    DSP_EMAIL: dsp?.email ?? '',
    DSP_TRADENAME: dsp?.tradeName ?? '',
    DSP_CONTACT: dsp?.contact ?? '',
    NAME: (da?.firstName ?? '') + ' ' + (da?.lastName ?? ''),
    EMAIL: da?.email ?? '',
    CONTACT: da?.primaryContact ?? '',
    POSITION: da?.positionType ?? '',
    WORKING_HOURS: workingHours,
    WORKING_DAYS: workingDays,
    HOURLY_RATE: hourlyRate,
    REGULAR_HOURLY_RATE: regularHourRate,
    SIGNATURE: signature ? [...signature.matchAll(/d="([^"]*)"/g)].map((match) => match[1]) : null,
    SUFFIX: `${globalutil?.suffixes().find((s) => da?.suffix == s.id)?.name ?? ''}`,
    DRUG_PROCEDURE: da?.drugProcedure ?? '',
    PRESCRIPTION: da?.prescription ?? '',
    NOTIFICATION_POLICY: da?.notificationPolicy ?? '',
  };
  const templatePath = path ?? '/templates/DSPOL.pdf';
  const existingPdfBytes = await fetch(templatePath)
    .then((res) => res.arrayBuffer())
    .catch((error) => {
      console.error('Error fetching PDF template:', error);
    });

  const pdfDoc = await PDFDocument.load(existingPdfBytes);
  if (templatePath.includes('BreakWaiver')) {
    breakWaiverPdf(pdfDoc, variables, breakWaiver);
    pdfDoc.setTitle('BreakWaiver');
  } else if (templatePath.includes('VTC')) {
    vtcPdf(pdfDoc, variables);
    pdfDoc.setTitle('VTC');
  } else if (templatePath.includes('CACTMC')) {
    cacPdf(pdfDoc, variables);
    pdfDoc.setTitle('CACTMC');
  } else if (templatePath.includes('BICF')) {
    bicfPdf(pdfDoc, variables);
    pdfDoc.setTitle('BICF');
  } else if (templatePath.includes('ESDC')) {
    disclousurePdf(pdfDoc, variables);
    pdfDoc.setTitle('ESDC');
  } else if (templatePath.includes('Handbook')) {
    pdfDoc.setTitle('Handbook');
    handbookPdf(pdfDoc, variables);
  }

  // Save the updated PDF
  const pdfBytes = await pdfDoc.save();

  // Create a Blob for download
  const blob = new Blob([pdfBytes], { type: 'application/pdf', endings: 'native' });

  // Create a URL for the Blob and open or download the PDF
  const url = URL.createObjectURL(blob);
  if (!onlyPreview) {
    window.open(url); // Open in new tab
  }
  return url;
};
